<template>
  <div class="message-container">
    <div class="message-wrapper">
      <p class="-title">
        <b>切り替えを行うロボを選択してください</b>
      </p>
      <div class="img-wrapper">
        <img class="img-icon" :src="getIconImage(scenarioEdit.parameter)">
      </div>
      <div class="select-wrapper">
        <b-field style="max-width: 100%;">
          <b-select placeholder="ロボ名" :value="selectedChatbot" @input="updateSelect"　:disabled="scenarioEdit.is_confirm">
            <option v-for="(bot, index) in filteredChatBots" :key="index" :value="bot.bot_id">
              {{bot.name}}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
    chatbots: {
      type: Array,
    }
  },
  computed: {
    filteredChatBots () {
      let ret = []
      for (const bot of this.chatbots) {
        if (bot.is_confirm) {
          ret.push(bot)
          for (const mini of bot.chatbot_mini) {
            let tempMini = mini
            // scenario nameも入れる
            tempMini.scenario_name = bot.scenario_name
            ret.push(tempMini)
          }
        }
      }
      return ret
    },
    selectedChatbot () {
      return this.scenarioEdit.parameter.bot_id
    }
  },
  methods: {
    updateSelect (event) {
      this.scenarioEdit.parameter = this.filteredChatBots.find(bot => bot.bot_id == event)
    },
    getIconImage (parameter) {
      if (parameter) {
        for (const bot of this.chatbots) {
          if (parameter.bot_id === bot.bot_id) {
            if (bot.icon_data) return bot.icon_data
          }
          for (const mini of bot.chatbot_mini) {
            if (parameter.bot_id === mini.bot_id) {
              if (mini.icon_data) return mini.icon_data
            }
          }
        }
      }
      return require('../../../../assets/template/robot.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.message-container {
  .message-wrapper {
    background-color:white;
    .-title {
      font-size: 16px;
      padding: 16px;
      text-align: center;
    }
    .img-wrapper {
      justify-content: center;
      display: flex;
    }
    .select-wrapper {
      font-size: 13px;
      padding: 16px;
      justify-content: center;
      display: flex;
    }
  }
  .message-content {
    margin-top: 8px;
  }
  .img-icon {
    width: 240px;
    height: 240px;
    object-fit: cover;
    border-radius: 50%;
    border: solid thin #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditChangeParts.vue